<template>
    <ad-form v-if="reconditionAdData"
                :allowed-image-types="allowedImageTypes"
                :max-file-size="maxFileSize"
                :offer="reconditionAdData"
                :save-handler="getHandleReconditionAd"
                :recondition-mode="true"
                :locale="locale"></ad-form>
</template>

<script>
import AdForm from "../AdForm";
import AdsApi from "../../services/AdsApi";

export default {
    name: 'ReconditionAd',
    components: {AdForm},
    data() {
        return {
            reconditionAdData: null
        };
    },
    props: [
        'locale',
        'allowedImageTypes',
        'maxFileSize',
        'deactivatedAdId',
        'csrfToken'
    ],
    created() {
        AdsApi.getFullAdData(this.locale, this.deactivatedAdId).then((response) => {
            this.reconditionAdData = response.data;
        });
    },
    methods: {
        getHandleReconditionAd(renewAdData) {
            return AdsApi.reconditionAd(renewAdData, this.locale, this.csrfToken).then(response => {
                return response.json();
            });
        }
    }
};
</script>

<style scoped>
</style>
